export default __webpack_public_path__ + "static/media/logo-enter-blue.e3afa168.svg";